import { api } from '@services';
import { IStudio } from '@models/Studio.model';

export interface IResponse {
  orgId: string;
  studio?: IStudio;
}
const getOrganizationByName = async (name: string): Promise<IResponse> => {
  const { data: organization } = await api.get(`/auth0/organizations/${name}`);
  return { orgId: organization.orgId, studio: organization?.studio };
};

export { getOrganizationByName };
